import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';

const PhosphatesProject = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white py-8">
      <div className="container mx-auto px-4 relative">
        <SectionTitle 
          overline={t('mining.phosphates.title')} 
          highlight={t('mining.phosphates.subtitle')} 
          separatorColor="socabeg-blue" 
          showLogo={true} 
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
          {/* Colonne 1 - LOCALISATION (image sans texte puis texte) */}
          <div className="flex flex-col h-full">
            {/* Image sans texte */}
            <div className="overflow-hidden">
              <img 
                src="/images/mines1.jpg" 
                alt="Mines 1" 
                className="w-full object-cover"
              />
            </div>
            
            {/* Contenu avec texte */}
            <div className="border border-gray-300 p-4 md:p-6 flex-grow">
              <div className="flex items-center mb-3">
                <div className="mr-3">
                  <svg className="w-6 h-6 md:w-8 md:h-8 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-socabeg-blue uppercase">{t('mining.phosphates.location.title')}</h3>
              </div>
              <p className="text-sm md:text-base text-gray-700 mb-4">{t('mining.phosphates.location.description')}</p>
              
              {/* Carte Google Maps avec marqueur style contact */}
              <div className="w-full h-48 mt-2 relative overflow-hidden rounded">
                <div className="absolute inset-0 bg-gray-200">
                  <iframe 
                    title="Carte de localisation de Thiès, Sénégal"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d122578.83770677532!2d-17.00131459157431!3d14.791252241475311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec1a5d95ee869dd%3A0x9a1b6d4b30a123e0!2sThi%C3%A8s%2C%20S%C3%A9n%C3%A9gal!5e0!3m2!1sfr!2sfr!4v1703016533037!5m2!1sfr!2sfr" 
                    width="100%" 
                    height="100%" 
                    style={{ border: 0 }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          
          {/* Colonne 2 - RESSOURCES (texte puis bg color sans texte) */}
          <div className="flex flex-col h-full">
            {/* Contenu avec texte */}
            <div className="border border-gray-300 p-4 md:p-6 flex-grow">
              <div className="flex items-center mb-3">
                <div className="mr-3">
                  <svg className="w-6 h-6 md:w-8 md:h-8 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M15.9,18.45C17.25,18.45 18.35,17.35 18.35,16C18.35,14.65 17.25,13.55 15.9,13.55C14.54,13.55 13.45,14.65 13.45,16C13.45,17.35 14.54,18.45 15.9,18.45M21.1,16.68L22.58,17.84C22.71,17.95 22.75,18.13 22.66,18.29L21.26,20.71C21.17,20.86 21,20.92 20.83,20.86L19.09,20.16C18.73,20.44 18.33,20.67 17.91,20.85L17.64,22.7C17.62,22.87 17.47,23 17.3,23H14.5C14.32,23 14.18,22.87 14.15,22.7L13.89,20.85C13.46,20.67 13.07,20.44 12.71,20.16L10.96,20.86C10.81,20.92 10.62,20.86 10.54,20.71L9.14,18.29C9.05,18.13 9.09,17.95 9.22,17.84L10.7,16.68L10.65,16L10.7,15.31L9.22,14.16C9.09,14.05 9.05,13.86 9.14,13.71L10.54,11.29C10.62,11.13 10.81,11.07 10.96,11.13L12.71,11.84C13.07,11.56 13.46,11.32 13.89,11.15L14.15,9.29C14.18,9.13 14.32,9 14.5,9H17.3C17.47,9 17.62,9.13 17.64,9.29L17.91,11.15C18.33,11.32 18.73,11.56 19.09,11.84L20.83,11.13C21,11.07 21.17,11.13 21.26,11.29L22.66,13.71C22.75,13.86 22.71,14.05 22.58,14.16L21.1,15.31L21.15,16L21.1,16.68Z" />
                  </svg>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-socabeg-blue uppercase">{t('mining.phosphates.resources.title')}</h3>
              </div>
              <ul className="list-disc pl-5 space-y-2 md:space-y-3 text-sm md:text-base">
                <li>{t('mining.phosphates.resources.point1')}</li>
                <li>{t('mining.phosphates.resources.point2')}</li>
                <li>{t('mining.phosphates.resources.point3')}</li>
              </ul>
            </div>
            
            {/* Image sans texte */}
            <div className="overflow-hidden">
              <img 
                src="/images/mines2.jpg" 
                alt="Mines 2" 
                className="w-full object-cover"
              />
            </div>
          </div>
          
          {/* Colonne 3 - PRODUCTION (image sans texte puis texte) */}
          <div className="flex flex-col h-full">
            {/* Image sans texte */}
            <div className="overflow-hidden">
              <img 
                src="/images/mines3.jpg" 
                alt="Mines 3" 
                className="w-full object-cover"
              />
            </div>
            
            {/* Contenu avec texte */}
            <div className="border border-gray-300 p-4 md:p-6 flex-grow">
              <div className="flex items-center mb-3">
                <div className="mr-3">
                  <svg className="w-6 h-6 md:w-8 md:h-8 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    <path d="M2.59,16.58L7.17,12L2.59,7.41L4,6L10,12L4,18L2.59,16.58Z" />
                  </svg>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-socabeg-blue uppercase">{t('mining.phosphates.production.title')}</h3>
              </div>
              <ul className="list-disc pl-5 space-y-2 md:space-y-3 text-sm md:text-base">
                <li>{t('mining.phosphates.production.point1')}</li>
                <li>{t('mining.phosphates.production.point2')}</li>
                <li>{t('mining.phosphates.production.point3')}</li>
                <li>{t('mining.phosphates.production.point4')}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhosphatesProject;
